var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAttachment = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "state=normal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 108",
    d: "M17.2344 9.25421V14.5826C17.2344 17.8963 14.5481 20.5826 11.2344 20.5826V20.5826C7.92067 20.5826 5.23438 17.8963 5.23438 14.5826L5.23438 5.92578C5.23438 3.71664 7.02524 1.92578 9.23438 1.92578V1.92578C11.4435 1.92578 13.2344 3.71664 13.2344 5.92578V15.0826C13.2344 16.1872 12.3389 17.0826 11.2344 17.0826V17.0826C10.1298 17.0826 9.23437 16.1872 9.23437 15.0826L9.23437 5.92578",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAttachment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/attachment.d573b47edc9f830a0431fb735e60275a.svg";